import {
  USERSELLERMENUFORM_FETCHITEMS_LOAD,
  USERSELLERMENUFORM_FETCHITEMS_SUCCEED,
  USERSELLERMENUFORM_ENTER_RESET,
  USERSELLERMENUFORM_FETCHITEMS_FAIL,
  USERSELLERMENUFORM_EDITFORM_CHANGE,
  USERSELLERMENUFORM_EDITITEM_LOAD,
  USERSELLERMENUFORM_EDITITEM_SUCCEED,
  USERSELLERMENUFORM_EDITITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case USERSELLERMENUFORM_FETCHITEMS_LOAD:
      return { ...state, isFetchSellerMenuItemsLoading: true, fetchSellerMenuItemsError: null }
    case USERSELLERMENUFORM_FETCHITEMS_SUCCEED:
      return { ...state, isFetchSellerMenuItemsLoading: false, items: action.items }
    case USERSELLERMENUFORM_FETCHITEMS_FAIL:
      return {
        ...state, isFetchSellerMenuItemsLoading: false, items: null, fetchSellerMenuItemsError: action.fetchSellerMenuItemsError,
      }
    case USERSELLERMENUFORM_ENTER_RESET:
      return {}
    case USERSELLERMENUFORM_EDITFORM_CHANGE:
      return { ...state, formFieldSellerMenuValues: { ...state.formFieldSellerMenuValues, ...action.field } }
    case USERSELLERMENUFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditSellerMenuItemLoading: true,
        isEditSellerMenuItemSuccess: false,
        editSellerMenuItemError: null,
      }
    case USERSELLERMENUFORM_EDITITEM_SUCCEED:
      return { ...state, isEditSellerMenuItemLoading: false, isEditSellerMenuItemSuccess: true }
    case USERSELLERMENUFORM_EDITITEM_FAIL:
      return { ...state, isEditSellerMenuItemLoading: false, editSellerMenuItemError: action.editSellerMenuItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/userSellerMenuForm.js